import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaChevronUp } from "react-icons/fa";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

// Quick Links section
const quickLinks: CustomLink[] = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About Us" },
  { href: "/our-product", label: "Our Products" },
  { href: "/blog", label: "Blog" },
  { href: "/contact", label: "Contact Us" },
];

// Categories section
const categories: CustomLink[] = [
  { href: "/our-product?categories=200", label: "CCTV Systems" },
  { href: "/our-product?categories=201", label: "Security Solutions" },
  { href: "/our-product?categories=202", label: "Network Equipment" },
  { href: "/our-product?categories=203", label: "Access Control" },
  { href: "/our-product?categories=204", label: "Fire Safety" },
];

// Company section
const companyLinks: CustomLink[] = [
  { href: "/privacy-policy", label: "Privacy Policy" },
  { href: "/terms", label: "Terms & Conditions" },
  { href: "/delete-account", label: "Delete Account" },
  { href: "/delete-data", label: "Delete Data" },
];

// Contact information
const contactInfo = {
  address: "1/1069, Dhobi Sheri, Nanpura, Surat, Gujarat 395001",
  phone: "098241 91662",
  email: "info@meetsolution.com",
  hours: "Mon - Fri: 9:00 AM - 6:00 PM"
};

// Social media links
const socialLinks = [
  {
    name: "Facebook",
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    href: "https://www.facebook.com/people/MEET-Solution-Incorporation/100057427150199/?",
    color: "hover:text-blue-500"
  },
  {
    name: "Instagram", 
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    href: "https://www.instagram.com/meet_solution_incorporation_?igsh=MW51Y2hhZDdxMjBoZA%3D%3D",
    color: "hover:text-pink-500"
  },
  {
    name: "YouTube",
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
    href: "https://www.youtube.com/@meetsolutionincorporation7595",
    color: "hover:text-red-500"
  }
];

const Footer: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Scroll to top functionality
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Show/hide scroll to top button
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <>
      <footer className="nc-Footer bg-gray-900 text-gray-300">
        {/* Main Footer Content */}
        <div className="container py-8 px-4 sm:py-12 sm:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 animate-fade-in">
            
            {/* Logo & About Section */}
            <div className="space-y-4 sm:space-y-6">
              <div className="flex-shrink-0">
                <Logo />
              </div>
              <div>
                <h2 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">MEET Solutions</h2>
                <p className="text-gray-300 text-sm leading-relaxed">
                  MEET Solutions is your trusted partner for comprehensive security and technology solutions. 
                  We provide cutting-edge CCTV systems, network equipment, and security solutions for businesses and homes.
                </p>
              </div>
            </div>

            {/* Quick Links Section */}
            <div className="space-y-3 sm:space-y-4">
              <h3 className="text-white font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Quick Links</h3>
              <ul className="space-y-2 sm:space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <NavLink
                      to={link.href}
                      className={({ isActive }) =>
                        `text-gray-400 hover:text-blue-300 transition-colors duration-200 text-sm leading-relaxed block ${
                          isActive ? 'font-semibold text-blue-400' : ''
                        }`
                      }
                    >
                      {link.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* Product Categories Section */}
            <div className="space-y-3 sm:space-y-4">
              <h3 className="text-white font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Product Categories</h3>
              <ul className="space-y-2 sm:space-y-3">
                {categories.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.href}
                      className="text-gray-400 hover:text-blue-300 transition-colors duration-200 text-sm leading-relaxed block"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info Section */}
            <div className="space-y-3 sm:space-y-4">
              <h3 className="text-white font-semibold mb-3 sm:mb-4 text-base sm:text-lg">Contact Info</h3>
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-5 h-5 mt-0.5">
                    <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    {contactInfo.address}
                  </p>
                </div>
                
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0 w-5 h-5">
                    <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a 
                    href={`tel:${contactInfo.phone}`}
                    className="text-gray-300 hover:text-blue-300 transition-colors duration-200 text-sm"
                  >
                    {contactInfo.phone}
                  </a>
                </div>
                
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0 w-5 h-5">
                    <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <a 
                    href={`mailto:${contactInfo.email}`}
                    className="text-gray-300 hover:text-blue-300 transition-colors duration-200 text-sm break-all"
                  >
                    {contactInfo.email}
                  </a>
                </div>
                
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0 w-5 h-5">
                    <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <p className="text-gray-300 text-sm">
                    {contactInfo.hours}
                  </p>
                </div>
                
                {/* Social Media Links */}
                <div className="pt-3 sm:pt-4">
                  <div className="flex flex-wrap gap-3 sm:gap-4">
                    {socialLinks.map((social, index) => (
                      <a
                        key={index}
                        href={social.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-gray-400 transition-colors duration-300 hover:scale-110 ${social.color}`}
                        title={social.name}
                      >
                        {social.icon}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-4 bg-gray-950">
          <div className="container py-4 sm:py-6 px-4 sm:px-8">
            <div className="text-center">
              <p className="text-gray-300 text-xs sm:text-sm">
                © {new Date().getFullYear()} MEET Solutions. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 bg-blue-600 hover:bg-blue-700 text-white p-2 sm:p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          aria-label="Scroll to top"
        >
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
        </button>
      )}
    </>
  );
};

export default Footer;
